import ProfilePhotoChanger from './ProfilePhotoChanger';

export default ProfilePhotoChanger;
